import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './form-field.magic.css.js';
import script from './form-field.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-field",class:{
        'has-success': _vm.hasSuccess,
        'has-alert': _vm.hasWarning && _vm.shouldDisplayMessage,
        'has-error': _vm.hasError && _vm.shouldDisplayMessage,
        'has-focus': _vm.focused,
        'has-label': !!_vm.label,
        'has-no-icon': _vm.noIcon,
        'form-field--no-margin': _vm.noMargin,
        'form-field--centered': _vm.centered,
        'form-field--consent': _vm.consent,
        'is-number': _vm.isFakeNumericPassword
    },attrs:{"part":_vm.$p('form-field', {
        'has-success': _vm.hasSuccess,
        'has-alert': _vm.hasWarning && _vm.shouldDisplayMessage,
        'has-error': _vm.hasError && _vm.shouldDisplayMessage,
        'has-focus': _vm.focused,
        'has-label': !!_vm.label,
        'has-no-icon': _vm.noIcon,
        'form-field--no-margin': _vm.noMargin,
        'form-field--centered': _vm.centered,
        'form-field--consent': _vm.consent,
        'is-number': _vm.isFakeNumericPassword
    }),"data-v-test-id":((_vm.$attrs['data-v-test-id']) + "-div")},on:{"input":function($event){return _vm.onInput($event)},"change":function($event){return _vm.onChange($event)},"!focus":function($event){return _vm.onFocus($event)},"!blur":function($event){return _vm.onBlur()}}},[(_vm.label)?_c('label',{staticClass:"label",attrs:{"part":"label"}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]):_vm._e(),_vm._v(" "),_vm._t("default",[_c(_vm.muggle ? 'ui-input' : 'magic-ui-input',_vm._b({ref:"input",tag:"component",staticClass:"field",class:{
                'form-field--no-margin': _vm.noMargin,
                'form-field--centered': _vm.centered,
            },attrs:{"part":_vm.$p('field', {
                'form-field--no-margin': _vm.noMargin,
                'form-field--centered': _vm.centered,
            }),"icon":(_vm.hasValidationState && !_vm.noIcon) || _vm.$attrs.icon}},'component',_vm.attributes,false)),_vm._v(" "),(_vm.hasSuccess && !_vm.noIcon)?_c('magic-ui-icon',{staticClass:"icon icon--success",attrs:{"name":"field-success","part":"icon icon--success","data-v-test-id":"icon-success"}}):(_vm.hasError && !_vm.noIcon)?_c('magic-ui-icon',{staticClass:"icon icon--error",attrs:{"name":"field-error","part":"icon icon--error","data-v-test-id":"icon-error"}}):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade-in-grow"}},[(_vm.shouldDisplayMessage && _vm.message)?_c('div',{staticClass:"message",attrs:{"part":"message"}},[_c('magic-ui-icon',{staticClass:"icon icon--error",attrs:{"name":"field-error","part":"icon icon--error"}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"text",attrs:{"data-v-test-id":"message-test","part":"text","content":_vm.message}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade-in-grow"}},[(_vm.hasInfo && _vm.info && !_vm.shouldDisplayMessage)?_c('div',{staticClass:"message",attrs:{"part":"message"}},[_c('magic-ui-text',{staticClass:"text",attrs:{"part":"text","content":_vm.info}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade-in"}},[(_vm.hasSuggestion && !_vm.focused)?_c('div',{staticClass:"message message--suggestion",attrs:{"part":"message message--suggestion","data-v-test-id":"form-field-suggestion"}},[_c('magic-ui-text',{staticClass:"text",attrs:{"part":"text","data-v-test-id":"form-field-suggestion-message","content":_vm.suggestionMessage}}),_vm._v(" "),_c('magic-ui-link',{staticClass:"link",attrs:{"part":"link","data-v-test-id":"form-field-suggestion-link"},on:{"click":_vm.applySuggestion}},[_vm._v("\n                "+_vm._s(_vm.suggestion)+"\n            ")])],1):_vm._e()])],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-d759b704_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-d759b704";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
